import * as React from 'react';
import { Input } from '@app/src/components/Input';
import { FormField } from './styled';

export const RenderInput = ({
  label,
  type,
  meta: { error, touched },
  maxLength,
  input,
  ...rest
}) => {
  let isError = (error && touched) ? error : '';
  return(
    <FormField label={label} portionWidth={1} errorMessage={isError} {...rest}>
      <Input type={type} {...input} {...rest} error={!!isError} maxLength={maxLength} />
    </FormField>
  );
}
